/* eslint-disable no-param-reassign */
import store from '@carvana/purchase-store';
import * as services from '../../services';
import * as types from '../action-types';

let requiredUnderwritingSteps = [
  'identityVerification',
  'proofOfIncome',
  'proofOfResidency',
  'tradeDocumentation',
  'additionalIncomeDocumentation',
  'bankAccountValidation',
  'transferSchedule'
];

const getStepByStepName = (stepName, steps) => {
  return steps[stepName] || {};
};

const completeStep = step => {
  if (Object.keys(step).length > 0) {
    step.isEnabled = false;
    step.status = 'Complete';
  }
};

const getCaseDefaults = () =>
  store.dispatch({
    type: types.GET_CASE_DEFAULTS,
    async payload() {
      return services.getCaseDefaults();
    }
  });

const requiredUnderwritingStepsComplete = (steps, needsToScheduleTimeSlot) => {
  const needsCompletion = [];

  if (!needsToScheduleTimeSlot) {
    requiredUnderwritingSteps = requiredUnderwritingSteps.filter(
      x => x !== 'transferSchedule'
    );
  }

  requiredUnderwritingSteps.forEach(rStep => {
    const step = steps[rStep] || {};
    if (step.isEnabled) needsCompletion.push(step);
  });

  const completeSteps = needsCompletion.filter(step => {
    return step?.status === 'Complete';
  });

  return needsCompletion?.length === completeSteps?.length;
};

const completeDocumentUpload = async () => {
  const { caseId } = store.getState().dashboard?.status || {};
  if (caseId) {
    await services.completeDocumentUpload(caseId);
  }

  return Promise.resolve();
};

const UnderwritingActions = async (res, availableOptions) => {
  const steps = res?.status?.steps;
  const { needsToScheduleTimeSlot } = availableOptions;

  await getCaseDefaults();

  if (!needsToScheduleTimeSlot) {
    const transferSchedule = getStepByStepName('transferSchedule', steps);

    completeStep(transferSchedule);
  }

  if (
    steps &&
    requiredUnderwritingStepsComplete(steps, needsToScheduleTimeSlot)
  ) {
    await completeDocumentUpload();
    res = await services.getDashboard();
  }

  return Promise.resolve(res);
};

export default UnderwritingActions;
